import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import AddTripForm from "./AddTripForm";

const AddTripDialog = ({ open, onOpenChange, onCreateTrip }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (tripData) => {
    setIsSubmitting(true);
    try {
      const result = await onCreateTrip(tripData);
      return result;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[96vw] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create New Trip</DialogTitle>
        </DialogHeader>
        <AddTripForm 
          onCreateTrip={handleSubmit} 
          onCancel={() => onOpenChange(false)} 
          isSubmitting={isSubmitting}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddTripDialog;